import { RefObject, useEffect, useRef } from 'react'

interface CallbackProps {
  width: number
  height: number
}

const useElementDimensions = (elRef: RefObject<HTMLElement>, callBack: (props: CallbackProps) => void) => {
  const observer = useRef(
    new ResizeObserver(entries => {
      const { height, width } = entries[0].contentRect
      callBack({ height, width })
    })
  )

  useEffect(() => {
    const current = observer.current
    const element = elRef.current
    if (element) current.observe(element)

    return () => {
      element
        ? current.unobserve(element)
        : current.disconnect()
    }
  }, [elRef, observer])
}

export default useElementDimensions